import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Statut d'une équipe (enum App\Entity\TeamStatus de l'API, GET /team_statuses) : Active, Archivée */
export default class TeamStatusModel extends AbstractApiModel {
  protected _path = '/team_statuses/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:team_status:${this.id}`);
  }
}
